import { useState } from 'react';
import {
  Datagrid,
  List,
  TextField,
  TextInput,
  BooleanField,
  EditButton,
  DeleteButton,
  FunctionField,
  useTranslate,
} from 'react-admin';
import { Chip, Box, Button } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTicketQueueErrorHandler } from './useTicketQueueErrorHandler';
import { TicketSettingsDialog } from '../tickets/components/dialogs';

const ticketQueueFilters = [
  <TextInput
    sx={{ marginBottom: 1 }}
    source="name"
    label="resources.ticket-queue.fields.name"
    defaultValue=""
    key="name_q"
    alwaysOn
  />,
];

const ColorField = ({ record }: { record?: { color?: string | null } }) => {
  if (!record?.color) return null;
  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '4px',
        backgroundColor: record.color,
        border: '1px solid rgba(0,0,0,0.2)',
      }}
    />
  );
};

const ListActions = () => {
  const translate = useTranslate();
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <>
      <Button
        startIcon={<SettingsIcon />}
        onClick={() => setSettingsOpen(true)}
        size="small"
      >
        {translate('resources.tickets.settings.title')}
      </Button>
      <TicketSettingsDialog
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      />
    </>
  );
};

export const TicketQueueList = () => {
  const onDeleteError = useTicketQueueErrorHandler('deleteFailed');

  return (
    <List filters={ticketQueueFilters} actions={<ListActions />}>
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sort={{ field: 'id', order: 'DESC' }}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="resources.ticket-queue.fields.name" />
        <FunctionField
          label="resources.ticket-queue.fields.color"
          render={(record: { color?: string | null }) => (
            <ColorField record={record} />
          )}
        />
        <FunctionField
          label="resources.ticket-queue.fields.isDefault"
          render={(record: { isDefault?: boolean }) =>
            record?.isDefault ? (
              <Chip label="Default" size="small" color="primary" />
            ) : null
          }
        />
        <EditButton />
        <DeleteButton
          mutationMode="pessimistic"
          mutationOptions={{ onError: onDeleteError }}
        />
      </Datagrid>
    </List>
  );
};
